import styled from "styled-components";
import Icon from "../../../components/icon";

export const Content = styled.div`
  position: relative;
`;

export const Overlay = styled.div`
  width: 427px;
  height: 444.04px;
  background: #000000;
  opacity: 0.8;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 16px;
  z-index: 2;

  &.left {
    left: 70px;
  }

  &.right {
    left: -70px;
  }

  &.hide {
    display: none;
  }

  @media (max-width: 1365px) {
    display: none;
  }
`;

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 427px;
  height: 535.4px;
  padding: 24px;
  background: #ffffff;
  border-radius: 16px;
  z-index: 3;

  &.overlay {
    width: 427px;
    height: 444.04px;
    margin-top: 45px;
    z-index: 1;
  }

  &.left {
    margin-left: 70px;
  }

  &.right {
    margin-left: -70px;
  }

  &.hide {
    display: none;
  }

  @media (max-width: 1365px) {
    width: 300px;
    height: 453px;
    margin: 0 auto;
    padding: 16px;

    &.left {
      margin-left: 0px;
    }

    &.right {
      margin-left: 0px;
    }

    &.overlay {
      width: 300px;
      height: 453px;
      margin: 0 auto;
      z-index: 1;
    }
  }
`;

export const CardTitle = styled.h2`
  font-family: "Rubik";
  font-style: normal;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 28px;
  text-align: center;
  text-transform: uppercase;
  color: #0b1943;
  margin: 0;

  @media (max-width: 1365px) {
    margin-bottom: 0;
    font-size: 1.25rem;
  }
`;

export const CardImage = styled.img`
  width: 331px;
  height: 186px;
  margin: 16px auto;
  background: ${(props) =>
      `url(assets/thumbnails/${props.asset}.png) center/cover no-repeat `},
    linear-gradient(0deg, #c4c4c4, #c4c4c4);

  &.overlay {
    width: 175px;
    height: 98px;
    background: ${(props) =>
      `url(assets/thumbnails/${props.asset}.png) center/cover no-repeat `};
  }

  @media (max-width: 1365px) {
    width: 266.67px;
    height: 150px;
    background: ${(props) =>
      `url(assets/thumbnails/${props.asset}.png) center/cover no-repeat `};
  }

  @media (max-width: 1365px) {
    width: 266.67px;
    height: 150px;
    background: ${(props) =>
      `url(assets/thumbnails/${props.asset}.png) center/cover no-repeat `};
  }

`;

export const ClassInfo = styled.div`
  width: 330px;
  padding-left: 36px;
  display: flex;
  align-items: center;

  &.highlight {
    background: #FF5227;
    border-radius: 8px;
    margin: 0;
    padding: 0;
  }

  @media (max-width: 1365px) {
    padding-left: 36px;
    max-width: 268px;
  }
`;

export const InfoText = styled.p`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 22px;
  color: #0b1943;
  margin: 8px 0;

  > strong {
    color: #0b1943;
    font-weight: 700;
    &.highlight {
      color: #ffffff;
    }
  }

  &.highlight {
    font-weight: 700;
    color: #ffffff;
    
    &:before {
      margin: 0 16px 0 10px;
      content: "•";
      color: white;
    }
  }

  @media (max-width: 1365px) {
    font-size: 14px;
    line-height: 19px;
  }
`;

export const BlackOffer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 16px;
  max-width: 100%;
  /* width: 333px;
  height: 373px; */
  padding: 54px 16px;
  background: #ffc400;
  border-radius: 8px;

  @media (max-width: 1365px) {
    padding: 46px 8px;
  }

  ${(props) =>
    props.isOverlay &&
    `
    padding: 14px 16px;
  `};
`;

export const OfferText = styled.p`
  margin-bottom: 24px;
  font-family: "Nunito";
  font-style: normal;
  text-align: center;

  &#not-available {
    font-weight: 700;
    font-size: 1rem;
    line-height: 22px;
    color: #0b1943;
  }

  &#offer {
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 27px;
    color: #0b1943;
  }

  &#price {
    font-weight: 900;
    font-size: 1rem;
    line-height: 22px;
    color: #265bf1;
  }

  @media (max-width: 1365px) {
    &#not-available {
      font-size: 0.875rem;
      line-height: 19px;
    }

    &#offer {
      font-size: 1rem;
      line-height: 22px;
    }

    &#price {
      font-size: 0.875rem;
      line-height: 19px;
    }
  }
`;

export const OfferButton = styled.button`
  width: 291px;
  height: 46px;
  background: #ed2929;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  border: none;
  cursor: pointer;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 22px;
  color: #ffffff;

  @media (max-width: 1365px) {
    width: 100%;
    height: 43px;
    font-size: 0.875rem;
  }
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin-top: auto;

  &.hide {
    display: none;
  }
`;

export const FooterButton = styled.button`
  width: 186px;
  height: 38px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 22px;
  text-align: center;

  &.e-book {
    border: 1px solid #265bf1;
    color: #265bf1;
    background: #ffffff;
    margin-right: 12px;

    &:disabled {
      border: 1px solid #ebe8e0;
      color: #ebe8e0;
      cursor: not-allowed;
    }
  }

  &.simulado {
    border: none;
    background: #ff5227;
    color: #ffffff;

    &:disabled {
      background: #ebe8e0;
      cursor: not-allowed;
    }
  }

  @media (max-width: 1365px) {
    width: 132px;
    height: 34px;
  }
`;

export const SocialIcon = styled(Icon)`
  fill: ${(props) => props.color};
  margin-right: 10px;
`;
